<template>
  <page>
    <template slot="content">
      <template>
        <list-group :title="'充電／お手入れ'">
          <list-item :spanText="'Q. '" :text="'充電マークが出ない/バッテリー残量が増えない'" :urlName="'Help26'"></list-item>
          <list-item :spanText="'Q. '" :text="'バッテリーの持ち時間について'" :urlName="'Help18'"></list-item>
        </list-group>
      </template>
    </template>
  </page>
</template>

<script>
  import ListGroup from '@/components/ListGroup'
  import ListItem from '@/components/ListItem'
  import Tab from '@/components/Tab'
  import TabBtn from '@/components/TabBtn'
  import TabContent from '@/components/TabContent'
  import Page from '@/components/Page'

  export default {
    name: 'HelpPage',
    components: {
      ListGroup,
      ListItem,
      Tab,
      TabBtn,
      TabContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/HelpCategory34.vue